var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedXMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "14-Invoices",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "14.07---Invoices---Error",
    transform: "translate(-832.000000, -513.000000)",
    fill: "#CC0000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(586.000000, 309.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(244.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(2.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.55432292,8.55348958 L12.7979583,5.30985417 C13.0039271,5.10402083 13.1068437,4.85390625 13.1068437,4.55964583 C13.1068437,4.26538542 13.0037917,4.01540625 12.7979583,3.8094375 L11.2975417,2.30888542 C11.0915729,2.10291667 10.8415937,2 10.5474687,2 C10.2530729,2 10.0030937,2.10291667 9.797125,2.30888542 L6.55348958,5.55252083 L3.30985417,2.30888542 C3.10402083,2.10291667 2.85390625,2 2.55964583,2 C2.26552083,2 2.01540625,2.10291667 1.8094375,2.30888542 L0.308885417,3.8094375 C0.103052083,4.01527083 -7.28306304e-14,4.26538542 -7.28306304e-14,4.55964583 C-7.28306304e-14,4.85390625 0.102916667,5.10388542 0.308885417,5.30985417 L3.55252083,8.55348958 L0.308885417,11.797125 C0.103052083,12.0030938 -7.28306304e-14,12.2530729 -7.28306304e-14,12.5473333 C-7.28306304e-14,12.8415938 0.102916667,13.0915729 0.308885417,13.2975417 L1.8094375,14.7979583 C2.01540625,15.0039271 2.26552083,15.1068438 2.55964583,15.1068438 C2.85390625,15.1068438 3.10388542,15.0037917 3.30985417,14.7979583 L6.55348958,11.5543229 L9.79726042,14.7979583 C10.0032292,15.0039271 10.2530729,15.1068438 10.5476042,15.1068438 C10.8417292,15.1068438 11.0918437,15.0037917 11.2976771,14.7979583 L12.7979583,13.2975417 C13.0039271,13.0917083 13.1068437,12.8415938 13.1068437,12.5473333 C13.1068437,12.2530729 13.0039271,12.0030938 12.7979583,11.797125 L9.55432292,8.55348958 L9.55432292,8.55348958 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedXMark);
export default __webpack_public_path__ + "static/media/Red_X_Mark.85dd4360c49a7686bc0ceede30891f76.svg";
export { ForwardRef as ReactComponent };